/**
 * Шаг мастера живёт на странице, а стрелка — в шапке лейаута.
 * Страница регистрирует обработчик, лейаут его вызывает.
 */
let headerBack: (() => void) | null = null

export function setImportHeaderBack(handler: (() => void) | null) {
  headerBack = handler
}

export function runImportHeaderBack() {
  headerBack?.()
}
